module.exports = __webpack_public_path__ + "img/pic_06@2x.2f3c358a.png";